import NsContent from 'components/common/ns-content/NsContent';

import { usePartner } from 'components/app/routes/usePartner';
import { QuoteBillingConsent } from 'components/direct-sales/quote/components/QuoteBillingConsent';
import { TariffFilters } from 'components/direct-sales/quote/components/TariffFilters';
import { PARTNERS } from 'config/app-config';
import { useTariffFilters } from 'components/direct-sales/quote/hooks/useTariffFilters';

export const testId = 'quoteSidebarLeftTestId';

export const QuoteSidebarLeft = () => {
  const { activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const { hasAnyFilter } = useTariffFilters();

  const hasLeftColumn = hasAnyFilter || !isMoveInJourney;

  if (!hasLeftColumn) {
    return null;
  }

  return (
    <NsContent role="listitem" data-testid={testId}>
      <QuoteBillingConsent shouldShow={!isMoveInJourney} />
      <TariffFilters />
    </NsContent>
  );
};

export default QuoteSidebarLeft;
